import FormContainer, { TextInputType } from '../formContainer/FormContainer'
import PropTypes from 'prop-types'
import EmailValidation from '../../api/EmailValidation'
import { emailRegEx } from '../../../utils/regExpressionsUtils'
import { useState } from 'react'
import { confirmEmailBlankErrorMessage, emailErrorMessage, emailAddressesDoNotMatchErrorMessage,
    emailAddressAlredyRegisteredErrorMessage, emailContainsMoreThanCharactersAllowed, maxLengthForEmail, emailFullMsgMarkup } from '../constants/Validations'

export default function EmailSection( props ) {
    
    const [ email, setEmail ] = useState( props.currentEmailValue ? props.currentEmailValue : '' )
    const [ emailConfirmation, setEmailConfirmation ] = useState( '' )
    const [ emailErrorMsg, setEmailError ] = useState( null )
    const [ confirmEmailErrorMsg, setConfirmEmailError ] = useState( null )
    const [ emailValueChanged, setEmailValueChanged ] = useState( '' )
    const [ displayConfirmEmail, setShowHideConfirmEmail ] = useState( email !== props.currentEmailValue )

    const handleEmailValid = ( e, isConfirmEmail ) => {
        
        email !== emailValueChanged ? setEmailValueChanged( email ) : setEmailValueChanged( emailValueChanged ) 
        
        if( email === emailConfirmation && confirmEmailErrorMsg === emailAddressesDoNotMatchErrorMessage ){
            setConfirmEmailError( null )
        }

        if( emailConfirmation || ( isConfirmEmail && e.target.value ) ) {
            if( email !== emailConfirmation || ( isConfirmEmail && e.target.value !== email ) ){
                setConfirmEmailError( emailAddressesDoNotMatchErrorMessage )
                props.setEmailIsValid( false )
            }
        }

        if( !e.target.value ){
            if( isConfirmEmail ){
                setConfirmEmailError( confirmEmailBlankErrorMessage )
            }else{
                setEmailError( emailErrorMessage )
            }
            
            props.setEmailIsValid( false )
        } 
        else 
        {
            const emailRegexPass = emailRegEx.regEx.test( e.target.value )

            if( isConfirmEmail ){
                setConfirmEmailError ( emailRegexPass ? null : emailErrorMessage )
                if( emailConfirmation && e.target.value !== email ){
                    setConfirmEmailError( emailAddressesDoNotMatchErrorMessage )
                    props.setEmailIsValid( false )
                }
            }
            else{
                if( !emailErrorMsg )
                    setEmailError  ( emailRegexPass ? null : emailErrorMessage )
            }
            
            if( !emailRegexPass ) {
                return
            }
        }

        if ( email.length > maxLengthForEmail || emailConfirmation.length > maxLengthForEmail ) {
            ( !isConfirmEmail ) ? setEmailError( emailContainsMoreThanCharactersAllowed ) : setConfirmEmailError( emailContainsMoreThanCharactersAllowed )
            props.setEmailIsValid( false )
            return   
        }
        
        if( !emailErrorMsg && !isConfirmEmail && email && emailValueChanged !== email && props.currentEmailValue !== email ) {
            props.setIsEmailValidationLoading( true )
            EmailValidation( { 
                apiUrl: process.env.REACT_APP_EMAIL_VALIDATION_API, 
                email: e.target.value, 
                webId: ''
            } )
            .then( data => {
                setEmailError  ( data ? emailAddressAlredyRegisteredErrorMessage : null )
                setEmail( e.target.value )
            } )
            .catch( data => {
                console.error( data )
            } )
            .finally( _ => {                
                props.setIsEmailValidationLoading( false )
            } )
        }
        
        if( !emailConfirmation && isConfirmEmail ){
            props.setEmailIsValid( false )
        }

        if( ( email === emailConfirmation || props.currentEmailValue === email ) && !emailErrorMsg && !confirmEmailErrorMsg ){
            props.setEmailIsValid( true )
        }else{
            props.setEmailIsValid( false )
        }
    }

    const handleEmailOnChange = ( e, isConfirmEmail ) => {
        if( isConfirmEmail ){
            setEmailConfirmation( e.target.value )
            props.setEmailValues( email, e.target.value )
        }
        else
        {
            setEmail( e.target.value )
            if( e.target.value === props.currentEmailValue ){                
                setShowHideConfirmEmail( false ) 
                setConfirmEmailError( '' )
                setEmailConfirmation( '' )
                props.setEmailIsValid( true )
            }else{
                setShowHideConfirmEmail( true ) 
            }
            
            props.setEmailValues( e.target.value, emailConfirmation )
        }

        if( emailRegEx.regEx.test(  e.target.value ) ) {
            isConfirmEmail ? setConfirmEmailError( null ) : setEmailError( null )
        }

        if( !emailConfirmation && isConfirmEmail ){
            props.setEmailIsValid( false )
        }
    }

    let adaTitle = 'Email (used for login) section. '
    if( props.showNotification ){
        adaTitle += emailFullMsgMarkup
    }    
    return(
        <FormContainer 
            formTitle = { 'Email (used for login)' }
            formTitleAdaMsg = { adaTitle  }
            formTitleClassName = "c-form-intro c-form-intro--long"
            containerClassName = "c-form-container c-form-container--box mb-5"
            formInputsClass =  'c-form-container-in-column'
            formInputComponents = { [ 
                { 
                    ...props.emailConfig,
                    value: email,
                    invalidText: emailErrorMsg,
                    invalid: emailErrorMsg ? true : false,
                    labelText: 'Email',
                    id: 'Email',
                    type: 'text',
                    autoComplete: 'false',
                    maxLength: 79,
                    tabIndex: 0,
                    ariaLabel: 'Enter Email field.',
                    visible: true,
                    inputType: TextInputType,
                    onBlur: ( e ) => handleEmailValid( e, false ),
                    onChange: ( e ) => handleEmailOnChange( e, false ),
                    onPaste: ( e ) => { e.preventDefault() },
                    onCopy: ( e ) => {
                        e.preventDefault()
                        e.clipboardData.setData( 'text/plain', e.target.value )
                    },
                }, 
                {
                    ...props.confirmEmailConfig,
                    value: emailConfirmation,
                    invalidText: confirmEmailErrorMsg,
                    invalid: confirmEmailErrorMsg ? true : false,
                    labelText: 'Confirm Email', 
                    id: 'ConfirmEmail', 
                    type: 'text', 
                    autoComplete: 'false',
                    maxLength: 79,
                    tabIndex: 0,
                    ariaLabel: 'Enter Confirm Email field.',
                    visible: props.showHideConfirmEmail ? displayConfirmEmail : true, 
                    inputType: TextInputType,
                    onBlur: ( e ) => handleEmailValid( e, true ),
                    onChange: ( e ) => handleEmailOnChange( e, true ),
                    onPaste: ( e ) => { e.preventDefault() },
                    onCopy: ( e ) => {
                        e.preventDefault()
                        e.clipboardData.setData( 'text/plain', e.target.value )
                    },
                } 
            ] }
            showInputComponentsInColum = { true }
            tooltipConfiguration = {
                {
                    text : 'After signing up, we suggest you go to your account settings and check that your email address used for notices and billing is correct.',
                    visible: props.dispalyToltip
                }
            }
            notification={ { ...props.notification } }
            notificationVisible = { props.showNotification }
        >
        </FormContainer>
    )
}

EmailSection.propTypes = {
    emailConfig: PropTypes.instanceOf( Object ),
    confirmEmailConfig: PropTypes.instanceOf( Object ),
    dispalyToltip: PropTypes.bool.isRequired,    
    setEmailIsValid: PropTypes.func.isRequired,
    setEmailValues: PropTypes.func.isRequired,
    setIsEmailValidationLoading: PropTypes.func.isRequired,
    currentEmailValue: PropTypes.string,
    showNotification: PropTypes.bool,
    notification: PropTypes.shape( {
        visible: PropTypes.bool,
        contentWrapper: PropTypes.string,
        markup: PropTypes.string
    } ),
    showHideConfirmEmail: PropTypes.bool
}